import styled from "@emotion/styled";

export const ChartWrapper = styled.div`
  .highcharts-container {
    overflow: visible !important;
  }
  & > * {
    overflow: visible !important;
  }
`;

export type ChartSeriesData = {
  name: string;
  displayName?: string;
  data: [number, number][];
  type: string;
  color: string;
  areaColor?: string;
};
